import React, { useEffect, useRef, useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { Collapse, Dropdown, Menu, Tooltip, Tag, Space, Row, Col, Divider, Select, Button } from 'antd';
import { UserOutlined, DownOutlined, ClockCircleOutlined, ReadOutlined, FileImageOutlined, EyeOutlined, EditOutlined, DeleteOutlined, NotificationOutlined, UserSwitchOutlined } from '@ant-design/icons';
import './List.less';
import { Demand, demandPageModel } from '../model'; // 假设你的模型文件是 models.ts 
import TextArea from 'antd/lib/input/TextArea'; 
import CommentList from '@/delivery/components/CommentList'; 
import moment from 'moment';
import { formatTimeDifference } from '@/utils/S';
import AddEdit from './AddEdit';
import UserIcon from '@/components/UserIcon/UserIcon';
import { CommentAE } from '@/common/model';
import { demandApi } from '../DemandApi';
import { ctrl } from '../controller';
import StatusSelect from '@/components/StatusSelect/StatusSelect';


const { Option } = Select
interface ListProps {
  list: Demand[];
}

const List: React.FC<ListProps> = observer(({ list }) => {

 

  const renderHeader = (demand: Demand) => (
    <Row className="list-item-header" align="middle" key={demand.id}>
      <Col className="left" span={12}>
        <span className="demand-code">#{demand.id}</span>
        <span className="description">{demand.content}</span>
        {/* <Tag color={getStatusColor(demand.status)}>{getStatusText(demand.status)}</Tag> */}
      </Col>
      <Col className="right" span={10}>
        <Space>
          <Tooltip title={demand.submitterName}>
               <UserIcon effect='post' id={demand.submitterId+''}></UserIcon>
          </Tooltip>
          <Divider type="vertical" />
          <Tooltip title={demand.executorName}>
               <UserIcon effect='leader' id={demand.executorId+''}></UserIcon>
          </Tooltip>
          <div onClick={(e) => e.stopPropagation()} className='status-select'>
                  {/* 状态快捷选择 */}
                  <StatusSelect
                    placeholder="项目状态"
                    value={demand.status}
                    valueList={[0,1,2]}
                    statusList={['待立项','已立项','已废弃']}
                    colorList={['#248dea','#0ea913','#979797']}
                    onChange={value => ctrl.changeStatus(demand.id, value)}
                    width={120}
                  > 
                  </StatusSelect> 
          </div>
          
        </Space>
      </Col>
    </Row>
  );
 
  const inputRef = useRef<HTMLInputElement>()

  useEffect((): (() => void) => {
    const handleKeyDown = (e) => {
      e.stopPropagation()

      if (e.keyCode === 13 && e.ctrlKey) {
        inputRef.current.blur()
        handleComment()
      }
    }

    document.addEventListener('keydown', handleKeyDown, false)

    return () => {
      document.removeEventListener('keydown', handleKeyDown, false)
    }
  }, [])

  const [comment, setComment] = useState('')

  const [isFocus, setFocus] = useState(false)

  const handleCommentChange = (e) => {
    setComment(e.target.value)
  }

  const handleFocus = () => {
     setFocus(true);
  }

  const handleBlur = () => {
    setFocus(false);
  }
  
  const handleComment = async () => {
    const commentAE : CommentAE = new CommentAE();
    commentAE.content = comment 
    await demandApi.addOrEditComment(commentAE); 
  }

  const [showAdd, setShowAdd] = useState(false)

  const getStatusColor = (status: number) => {
    switch (status) {
      case 0: return 'blue'; // 待立项
      case 1: return 'green'; // 已立项
      case 2: return 'grey'; // 已废弃
      default: return 'white';
    }
  };

  const getStatusText = (status: number) => {
    switch (status) {
      case 0: return '待立项';
      case 1: return '已立项';
      case 2: return '已废弃';
      default: return '未知';
    }
  };

  const store = useLocalObservable(() => ({
    activeKey: [] as any
  }))
  useEffect(() => {
    // @ts-ignore
    window.onGlobalEvent('bugFolderAll', () => {
      store.activeKey = []
    })
    return () => {
      // @ts-ignore
      window.offGlobalEvent('bugFolderAll')
    }
  }, [])
  
  const getStatusMenu = (demand: Demand) => (
    <Menu>
      <Menu.Item key="0">待处理</Menu.Item>
      <Menu.Item key="1">已立项</Menu.Item>
      <Menu.Item key="2">已废弃</Menu.Item>
    </Menu>
  );  

  const [selectedDemand, setSelectedDemand] = useState<Demand | undefined>(undefined);
  const [isModalVisible, setIsModalVisible] = useState(false);

 
  const handleEdit = (demand: Demand) => {
    setSelectedDemand(demand);
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };



  return (
    <Collapse
      activeKey={store.activeKey}
      onChange={(e) => (store.activeKey = e)}
    >
      {list.map((demand,index) => (
        <Collapse.Panel showArrow={false} header={renderHeader(demand)} key={index}>
          <Space className="details w-full">
            <Row>
              <Col span={12} className='icon-info-list-container'>
                    <Row className='first-row info-row'>
                          <Col span={1}></Col>
                          <Col span={2}>  
                              <ClockCircleOutlined  />
                          </Col>
                          <Col span={21} style={{paddingRight:20}}>
                              <span className="">{moment(demand.submitTime).format('YYYY年MM月DD日 HH:mm')}</span>
                          </Col>
                    </Row>
                    <Row className=' info-row'>
                          <Col span={1}></Col>
                          <Col span={2}>  
                              <ReadOutlined  />
                          </Col>
                          <Col span={21} style={{paddingRight:20}}>
                               <span style={{ whiteSpace: 'pre-wrap' }}>{demand.content}</span>
                          </Col>
                    </Row>
                    <Row className=' info-row'>
                          <Col span={1}></Col>
                          <Col span={2}>  
                             <UserSwitchOutlined />
                          </Col>
                          <Col span={21} style={{paddingRight:20}}>
                               <span style={{ whiteSpace: 'pre-wrap' }}>
                                  <UserIcon showName effect='post' id={demand.submitterId+''}></UserIcon>
                               </span>
                          </Col>
                    </Row> 
                    <Row className=' info-row'>
                          <Col span={1}></Col>
                          <Col span={2}>  
                              <UserOutlined />
                          </Col>
                          <Col span={21} style={{paddingRight:20}}>
                               <span style={{ whiteSpace: 'pre-wrap' }}>
                                  <UserIcon showName effect='leader' id={demand.executorId+''}></UserIcon>
                               </span>
                          </Col>
                    </Row> 
                    <Row className='last-row info-row'>
                          <Col span={1}></Col>
                          <Col span={2}>  
                              <EyeOutlined  />
                          </Col>
                          <Col span={21} className='event-list'>
                              {
                                // 操作日志
                                demand.logs.map( (operation)=>(
                                      <div key ={operation.id}> 
                                        <span className='name-hint'>{operation.operatorId?operation.operatorName:'未知'} </span>
                                        <span>{operation.content}</span>
                                        <span className='time-desc'>{operation.logTime?formatTimeDifference(operation.logTime):''} </span>
                                      </div> 
                                  )
                                )
                              } 
                          </Col>
                    </Row> 
              </Col>
              <Col span={4} className='edit-operation-area-middle'>
                    <Space size={0}>
                            <Button
                              type="link"
                              icon={<EditOutlined />}
                              onClick={() => handleEdit(demand)}
                            >
                              编辑
                            </Button>
                            <Button
                              type="link"
                              danger
                              icon={<DeleteOutlined />}
                              onClick={(e) => {
                                e.stopPropagation()
                                demandApi.deleteDemand(demand.id)
                              }}
                            >
                              删除
                            </Button>
                    </Space>
              </Col>
              <Col span={8}>
                 <div className="flex flex-col" style={{ padding: '0 20px' }}>
                    <TextArea
                        allowClear
                        ref={inputRef}
                        autoSize={{ minRows: 1, maxRows:2 }}
                        placeholder="有什么想说的吗？"
                        value={ comment}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        onChange={handleCommentChange}
                        className='comment-content-input'
                        
                      />
                    <div style={{textAlign:'left',fontSize:13, paddingBlock:12}}>评论({demand.comments.length})</div>
                    <CommentList oldDataSource={null} newDataSource={demand.comments} />
                  </div>
              </Col>
            </Row>
           
           
          </Space>
        </Collapse.Panel>
      ))}
      <AddEdit
          visible={isModalVisible}
          onClose={handleCloseModal}
          demand={selectedDemand}
       />
    </Collapse>
  );
});

export default List;